<template>
<div class="card">
  <div class="card-header" v-if="header">
    <h3>{{header}}</h3>
  </div>
  <div class="card-body">
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  name: "Card",
  props:['header']
}
</script>

<style scoped>

</style>
